import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";

export function CandyMarquee() {
  const [products, setProducts] = useState([]);
  useEffect(() => { http.get("/products").then(({ data }) => setProducts(data.products)).catch(() => {}); }, []);
  if (products.length === 0) return null;
  const items = products.filter((p) => p.image);
  const tripled = [...items, ...items, ...items];
  return (
    <div className="bg-[#1A1A1A] text-[#FFFDF8] overflow-hidden border-b border-white/10" data-testid="candy-marquee">
      <div className="flex whitespace-nowrap animate-marquee-slow py-3">
        {tripled.map((p, i) => (
          <Link
            key={`${p.id}-${i}`}
            to={`/product/${p.id}`}
            className="mx-6 shrink-0 flex items-center gap-3 group"
          >
            <img src={p.image} alt="" className="w-9 h-9 object-contain shrink-0 group-hover:rotate-12 transition-transform" />
            <span className="font-heading text-sm uppercase tracking-[0.2em] group-hover:text-[#FFB300]">{p.name}</span>
            <span className="text-[10px] tracking-widest uppercase text-[#FFB300]">${p.retail_msrp?.toFixed(2)}</span>
            <span className="text-white/30 text-lg">·</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
